import TrademarkDetails from './TrademarkDetails'
export default [
    {
        name: 'TmAll',
        path: 'TmAll',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmAll'),
        meta: { title: '全部' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmToBeDeclared',
        path: 'TmToBeDeclared',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmToBeDeclared'),
        meta: { title: '待申报' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmDeclaring',
        path: 'TmDeclaring',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmDeclaring'),
        meta: { title: '申报中' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmDeclaredUnderReview',
        path: 'TmDeclaredUnderReview',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmDeclaredUnderReview'),
        meta: { title: '已申报-审查中' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmRejected',
        path: 'TmRejected',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmRejected'),
        meta: { title: '驳回/审查意见' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmPreliminaryExamination',
        path: 'TmPreliminaryExamination',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmPreliminaryExamination'),
        meta: { title: '初审/公告' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmBeObjected',
        path: 'TmBeObjected',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmBeObjected'),
        meta: { title: '被异议' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmCertificateIssued',
        path: 'TmCertificateIssued',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmCertificateIssued'),
        meta: { title: '已下证' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TmInvalidated',
        path: 'TmInvalidated',
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling/TmInvalidated'),
        meta: { title: '已作废' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'TrademarkDetails',
        path: 'TrademarkDetails',
        redirect: { name: 'SubmissionMaterials' },
        component: () => import('@/pages/BigData/TrademarkModule/TrademarkDetails'),
        meta: { title: '详情' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children: [...TrademarkDetails]
    },
]